import { Component, Prop, Vue } from "vue-property-decorator";

import Card from "@/components/Card.tsx";
import { CreateElement } from "vue";
import { db, balaCollection, userDataCollection } from "@/firebase";
import { updateStudentScoring } from "@/service/DashboardBackend";

@Component
export default class ReadingTask3Questions extends Vue {
  dialog = false;
  valid = true;
  private balaTasks: any;
  private _passage: [];
  private _questions: [
    { question: string; responses: Array<string>; answer: number; qid: number }
  ];

  constructor() {
    super();
    this._passage = this.$store.getters.balaPassages.readingTask3;
    this._questions = this.$store.getters.balaQuestions.readingTask3;
    this.balaTasks = this.$store.getters.balaSections;
  }

  beforeCreate() {
    this._passage = this.$store.getters.balaPassages.readingTask3;
    this._questions = this.$store.getters.balaQuestions.readingTask3;
    this.balaTasks = this.$store.getters.balaSections;
  }

  getData() {
    let data: any = [];
    this._questions.forEach(function(item) {
      data.push({
        question: item.question,
        answer: item.answer, // answer '1' maps to '0' (and so on...) on the responses list.
        qid: item.qid
      });
    });
    return data;
  }

  private isComplete() {
    return this.$store.getters.balaSections[3].sectionProgress.Questions == 100;
  }

  submit() {
    if (this.$store.getters.balaSections[3].sectionProgress.Questions != 100) {
      var thisUser = this.$store.getters.user;
      var uid = thisUser.data.uid;

      let timepoint = this.$store.getters.balaTimepointStr;
      let data = this.getData();

      updateStudentScoring();

      // Store question answers
      userDataCollection
        .doc(uid)
        .collection("bala")
        .doc(timepoint)
        .collection("responses")
        .doc("readingTask3")
        .set(
          {
            QuestionsAnswers: data
          },
          { merge: true }
        )
        .then(function() {
          userDataCollection
            .doc(uid)
            .collection("bala")
            .doc(timepoint)
            .update({
              "completionStatus.readingTask3.questions": {
                status: true,
                dateCompleted: Date.now()
              }
            });
        })
        .catch(function(error) {
          //console.error("Error writing response for Bala Reading Task 1 Questions: ", error);
        });

      // Update progress in $store
      this.$store.dispatch("updateBalaProgress", {
        section: "Reading Task 3",
        subsection: "Question"
      });
    }
    this.$router.push({ name: "balaRT4Intro" });
  }

  stateLoaded() {
    return this.$store.getters.balaQuestionsLoaded;
  }

  render(h: CreateElement) {
    return (
      this.stateLoaded() && (
        <Card>
          <v-toolbar flat slot="preTitle">
            <div style={{ marginLeft: "auto" }}>
              <v-btn
                onClick={() => {
                  this.dialog = true;
                }}
                color="secondary"
              >
                Show me the passage
              </v-btn>
              <v-dialog v-model={this.dialog}>
                <v-card class="elevation-12">
                  <v-card-title>{this.balaTasks[3].name}</v-card-title>
                  <v-list class="overflow-y-auto" max-height="400">
                    {this._passage.map((line, i) => (
                      <v-list-item>
                        <v-row>
                          <v-col cols="1">{i + 1}</v-col>
                          <v-col cols="11">{line}</v-col>
                        </v-row>
                      </v-list-item>
                    ))}
                  </v-list>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="secondary"
                      onClick={() => {
                        this.dialog = false;
                      }}
                    >
                      Close
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </div>
          </v-toolbar>
          <div slot="mainContent" class="overflow-y-auto">
            <b>
              Please select the best answer for each of the following questions.
            </b>
            <v-form ref="form" v-model={this.valid}>
              <v-list max-height="300">
                {this._questions.map((question: any, i) => (
                  <div>
                    <v-list-item>
                      <v-row>
                        <v-col>
                          {this.$createElement("span", {
                            domProps: {
                              innerHTML: i + 1 + ". " + question.question
                            }
                          })}
                        </v-col>
                      </v-row>
                    </v-list-item>
                    <v-list-item>
                      <v-row>
                        {question.responses ? (
                          <v-col
                            cols="1"
                            style={{ paddingBottom: "0", marginBottom: "0" }}
                          ></v-col>
                        ) : (
                          ""
                        )}
                        <v-col
                          cols={!question.responses ? "12" : "11"}
                          style={{ paddingBottom: "0", marginBottom: "0" }}
                        >
                          {!question.responses ? (
                            <v-textarea
                              class="mx-4"
                              v-model={question.answer}
                              counter
                              disabled={this.isComplete()}
                              placeholder="Start writing here..."
                              rules={[
                                (v: any) =>
                                  (v.length > 0 && v.length < 2500) ||
                                  "Max 500 words"
                              ]}
                            ></v-textarea>
                          ) : (
                            <v-radio-group
                              column
                              v-model={question.answer}
                              disabled={this.isComplete()}
                              rules={[(v: any) => v >= 0 || "Item is required"]}
                              style={{ paddingTop: "0", marginTop: "0" }}
                            >
                              {[0, 1, 2, 3].map(n => (
                                <v-radio
                                  key={n}
                                  value={n}
                                  label={question.responses[n]}
                                ></v-radio>
                              ))}
                            </v-radio-group>
                          )}
                        </v-col>
                      </v-row>
                    </v-list-item>
                  </div>
                ))}
              </v-list>
            </v-form>
          </div>
          <div slot="actions">
            <v-spacer></v-spacer>
            <v-btn
              disabled={!this.valid}
              color="secondary"
              onClick={this.submit}
            >
              Next
            </v-btn>
          </div>
          <div slot="progressBar">
            <v-spacer></v-spacer>
            <v-progress-linear
              value={Math.round(this.$store.getters.progressBala)}
              height="4"
              opacity="0.3"
              striped={true}
            ></v-progress-linear>
          </div>
        </Card>
      )
    );
  }
}

const component = ReadingTask3Questions;
